import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-signup-details-slideout',
  templateUrl: './signup-details-slideout.component.html',
  styleUrls: ['./signup-details-slideout.component.css']
})
export class SignupDetailsSlideoutComponent implements OnInit {

 @Input() signUpdetailObj:any;
  @Input() drivers: any;
  @Input() vehicles: any;
 @Output() closeModal = new EventEmitter<any>
 
  constructor (){}

  ngOnInit(): void {
    console.log("signUpdetailObj", this.signUpdetailObj)
  }

  onCloseModal(){
    this.closeModal.emit();
  }

}
